import {fetchTracePricingAnalytics, fetchTracePricingPeriod, SummaryType} from '@ls/grouping-service';
import {exchange} from '@ls/js-fetch';
import SelectionState from 'state/selections/SelectionState';
import {selectGetGroupingParams} from 'state/selections/selectors';
import {splitByCalcType} from 'state/util';
import scope from './scope';
import {selectDefinitions} from './selectors';

export const DELETE_DEFINITION = `${scope}/DELETE_DEFINITION`;
export const SET_DEFINITION = `${scope}/SET_DEFINITION`;
export const setDefinition = (idx, definition) => ({
  type: SET_DEFINITION,
  idx,
  definition,
});
export const SET_DEFINITIONS = `${scope}/SET_DEFINITIONS`;
export const setDefinitions = (definitions) => ({
  type: SET_DEFINITIONS,
  definitions,
});

export const REQUEST_TRACE_ANALYTIC_VALUES = `${scope}/REQUEST_TRACE_ANALYTIC_VALUES`;
export const RECEIVE_TRACE_ANALYTIC_VALUES = `${scope}/RECEIVE_TRACE_ANALYTIC_VALUES`;
export const requestTraceAnalyticValues = () => {
  return async (dispatch) => {
    dispatch({type: REQUEST_TRACE_ANALYTIC_VALUES});
    const result = await fetchTracePricingAnalytics();
    dispatch({
      type: RECEIVE_TRACE_ANALYTIC_VALUES,
      data: result,
    });
  };
};
export const REQUEST_TRACE_PERIOD_VALUES = `${scope}/REQUEST_TRACE_PERIOD_VALUES`;
export const RECEIVE_TRACE_PERIOD_VALUES = `${scope}/RECEIVE_TRACE_PERIOD_VALUES`;
export const requestTracePeriodValues = () => {
  return async (dispatch) => {
    dispatch({type: REQUEST_TRACE_PERIOD_VALUES});
    const result = await fetchTracePricingPeriod();
    dispatch({
      type: RECEIVE_TRACE_PERIOD_VALUES,
      data: result,
    });
  };
};

export const REQUEST_GRID_DATA = `${scope}/REQUEST_GRID_DATA`;
export const RECEIVE_GRID_DATA = `${scope}/RECEIVE_GRID_DATA`;
export const requestGridData = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const definitions = selectDefinitions(SelectionState.COMMITTED)(state);
    if (!definitions?.length) {
      return
    }

    const [absDefinitions, bmkDefinitions, relDefinitions] = splitByCalcType(definitions);
    const getGroupingParams = selectGetGroupingParams(SelectionState.COMMITTED)(state);
    const request = async (summary, definitions, benchesToo) => {
      dispatch({type: REQUEST_GRID_DATA, summary});

      const params = getGroupingParams({
        summary,
        benchesToo,
        results: ['TRACE_PRICING'],
        trace_pricing_analytics: [...new Set(definitions.map(def => def.traceAnalytic))],
        trace_pricing_periods: [...new Set(definitions.map(def => def.tracePeriod))],
      });

      dispatch({
        type: RECEIVE_GRID_DATA,
        summary,
        data: (await exchange({
          params,
          cancelId: `data-${scope}-${summary}`,
          url: process.env.REACT_APP_BASE_URL_GROUPING_SERVICE,
        }))?.data,
      });
    };

    if (absDefinitions.length || bmkDefinitions.length) {
      request(
        SummaryType.ABSOLUTE,
        [...absDefinitions, ...bmkDefinitions],
        bmkDefinitions.length > 0,
      ).then()
    }

    if (relDefinitions.length) {
      request(
        SummaryType.RELATIVE,
        relDefinitions,
        true,
      ).then()
    }

  }

};
